import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string | false;
  title?: string | false;
} = {
  navTheme: 'realDark',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: false,
  pwa: true,
  logo: false,
  iconfontUrl: '',
  contentStyle: {
    backgroundColor: '#111124',
    color: "#FFFFFF",
  },
  token: {
    sider:{
      colorTextMenu: "rgba(234, 238, 255, 1)",
      colorBgMenuItemSelected: "#2C74C0",
      colorTextMenuSelected: "#FFFFFF",
      colorBgMenuItemHover: "#2b74bf",
      colorBgMenuItemActive: "#2b74bf",
      colorTextMenuActive: "#2b74bf",
      colorMenuBackground: "#161632",
      colorTextMenuItemHover: "#FFFFFF",
    },
    header: {
      heightLayoutHeader: 1,
      colorBgHeader: "#2C74C0",
    },

    // pageContainer: {
    //   colorBgPageContainer: "rgba(239, 239, 239, 1)",
    // }

    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
